<template>
  <div>
    <div class="top_tit">
      <div class="line"></div>
      <p>{{ text.Name }}</p>
    </div>
    <div class="bottom_content">
      <!-- 暂无文本 -->
      <!-- <van-empty description="暂无文本" image-size="40" /> -->
      <!-- <div v-if="item.Content != '' && item.Content" class="bottom_content_box">
        <p v-html="item.Content"></p>
      </div> -->
      <ReadArticle
        v-if="text.Content != '' && text.Content"
        :content="text.Content ? text.Content.replace(/\n/g, '<br/>') : ''"
      />
      <van-empty v-else description="暂无文本" image-size="40" />

      <!-- <div class="btn" @click="myAsk">上传文本</div> -->
    </div>
  </div>
  <!-- <div v-if="text.length == '0'" class="list_box">
    <div class="top_tit">
      <div class="line"></div>
      <p>文本框</p>
    </div>
    <div class="bottom_content">
      <van-empty description="暂无文本" image-size="40" />
    </div>
  </div> -->
</template>

<script>
  import ReadArticle from '@/components/ReadArticle'
  import { ref, onActivated, onDeactivated, onMounted } from 'vue'
  import router from '@/router'
  export default {
    components: {
      ReadArticle,
    },
    props: {
      // eslint-disable-next-line vue/require-default-prop
      text: {
        type: Object,
      },
    },
    setup(props) {
      // onMounted(() => {
      //   console.log('props ', props.text)
      // })
      // const textData = ref([
      //   {
      //     Content:
      //       '商业的本质一定是为这个社会解决问题，一切要围绕创造价值出发。商业的本质一定是为这个社会解决问题，一切要围绕创造价值出发。商业的本质一定是为这个社会解决问题，一切要围绕创造价值出发。商业的本质一定是为这个社会解决问题，一切要围绕创造价值出发。商业的本质一定是为这个社会解决问题，一切要围绕创造价值出发。\n\n接下来你将学习的个人品牌体系威力会非常大，我希望你在做每一个抉择和判断时，都是合法、合规、并且道德善良的。\n\n因为商业技巧，将决定你飞的有多快；\n\n而商业道德，将会决定你飞的有多远。\n\nStay Hungry Stay Foolish\n求知若饥 虚心若愚\n\n请仔细学习下方的必修课',
      //     ModuleCode: 'Text',
      //     ModuleInstanceId: '1519510448792277009',
      //     Name: '文本框',
      //     Sort: 1,
      //     Visible: true,
      //   },
      //   {
      //     Content:
      //       '商业的本质一定是为这个社会解决问题，一切要围绕创造价值出发。\n\n接下来你将学习的个人品牌体系威力会非常大，我希望你在做每一个抉择和判断时，都是合法、合规、并且道德善良的。\n\n因为商业技巧，将决定你飞的有多快；\n\n而商业道德，将会决定你飞的有多远。\n\nStay Hungry Stay Foolish\n求知若饥 虚心若愚\n\n请仔细学习下方的必修课',
      //     ModuleCode: 'Text',
      //     ModuleInstanceId: '1519510448792277009',
      //     Name: '文本框22',
      //     Sort: 3,
      //     Visible: true,
      //   },
      // ])
      // const myAsk = () => {
      //   console.log('我要提问 :>> ')
      //   router.push({
      //     path: '/service/askAdd',
      //   })
      // }
      // return {
      //   myAsk,
      // }
    },
  }
</script>

<style lang="scss" scoped>
  .bottom_content {
    position: relative;
    padding: 15px;

    .bottom_content_box {
      overflow-y: auto;
      p {
        font-size: 14px;
        color: #333333;
      }
    }

    .btn {
      width: 100%;
      height: 32px;
      background-color: #b57e48;
      border-radius: 4px;
      text-align: center;
      line-height: 32px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      margin: 15px 0;
    }
  }
</style>
